import { render } from "./FixEmployeePunch.vue?vue&type=template&id=4b05df28"
import script from "./FixEmployeePunch.vue?vue&type=script&lang=js"
export * from "./FixEmployeePunch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__